<script>
  import {
    BANK_REG_NUMBER_LENGTH,
    GB_BANK_REG_NUMBER_LENGTH,
    GB_COUNTRY,
    CLASSIC_FORMAT_IBAN_COUNTRIES,
    CLASSIC_FORMAT_NO_REG_NUMBER_COUNTRIES,
    IBAN_LENGTHS,
    MAX_BANK_ACCOUNT_GB_LENGTH,
    MAX_BANK_ACCOUNT_LENGTH,
    MAX_BANK_ACCOUNT_NORWAY_LENGTH,
    MAX_IBAN_LENGTH,
    NORWAY_COUNTRY,
    ISO_20022_IBAN,
  } from '@base/configs'

  export default {
    methods: {
      isIbanBankFormat (formatCode) {
        return formatCode === ISO_20022_IBAN
      },

      isClassicFormatIbanCountry (countryCode) {
        return CLASSIC_FORMAT_IBAN_COUNTRIES.includes(countryCode)
      },

      accountIsIban (countryCode, formatCode) {
        return this.isIbanBankFormat(formatCode) || this.isClassicFormatIbanCountry(countryCode)
      },

      usesBankRegNumber (countryCode, formatCode) {
        if (this.isIbanBankFormat(formatCode)) {
          return false
        }
        return !CLASSIC_FORMAT_NO_REG_NUMBER_COUNTRIES.includes(countryCode)
      },

      bankAccountLengthFor (countryCode, formatCode) {
        // A cross-border IBAN can be any country's length, so ibanValidator checks the exact size.
        if (this.isIbanBankFormat(formatCode)) {
          return MAX_IBAN_LENGTH
        }
        if (countryCode === NORWAY_COUNTRY) {
          return MAX_BANK_ACCOUNT_NORWAY_LENGTH
        }
        if (countryCode === GB_COUNTRY) {
          return MAX_BANK_ACCOUNT_GB_LENGTH
        }
        if (this.isClassicFormatIbanCountry(countryCode)) {
          return IBAN_LENGTHS[countryCode]
        }
        return MAX_BANK_ACCOUNT_LENGTH
      },

      bankRegNumberLengthFor (countryCode) {
        return countryCode === GB_COUNTRY ? GB_BANK_REG_NUMBER_LENGTH : BANK_REG_NUMBER_LENGTH
      },

      padBankAccount (value, countryCode, isSolo, formatCode) {
        if (isSolo || this.accountIsIban(countryCode, formatCode)) {
          return value
        }
        return String(value || '').padStart(this.bankAccountLengthFor(countryCode), '0')
      },
    }
  }
</script>
